import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    GetAccessLogEntryById,
    GetAccessLogExitById
} from "../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi";
import {equipmentListToLabel, errorMsg} from "../../../../../Apis/functions";
import {ACCESS_TYPE_MATERIAL_MODEL} from "../../../Contractors/Model/Models";
import {CHECK_IN_MODEL} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 03 de diciembre de 2025
 *
 * Custom logic handler for the Log Modal.
 * Manages equipment lists, employee log details, and fetches log information
 * for a selected contractor or employee.
 */
export const LogModalApp = ({ itemSelected, out }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [checkInItem, setCheckInItem] = useState(null);
    const [checkOutItem, setCheckOutItem] = useState(null);
    const [equipmentIn, setEquipmentIn] = useState([]);
    const [equipmentOut, setEquipmentOut] = useState([]);

    useEffect(() => {
        if (itemSelected?.equipmentAccessLogId) {
            if(out) setCheckOutData();
            else setCheckInData();
        }
    }, [itemSelected?.equipmentAccessLogId]);


    const setCheckInData = () => {
        dispatch(GetAccessLogEntryById(itemSelected?.equipmentAccessLogId))
            .then(({ payload: { data:{data, success, code} } }) => {
                if (success) {
                    setCheckInItem(CHECK_IN_MODEL.set(data));
                    if(data?.equipmentList?.length > 0)
                        setEquipmentIn(equipmentListToLabel(data?.equipmentList));
                } else {
                    errorMsg(code);
                }
            });
    };

    const setCheckOutData = () => {
        dispatch(GetAccessLogExitById(itemSelected?.equipmentAccessLogId))
            .then(({ payload: { data:{data, success, code} } }) => {
                if (success) {
                    let checkInData;
                    let checkOutData;

                    for (const e of data ?? []) {
                        if (e.accessType === ACCESS_TYPE_MATERIAL_MODEL.ENTRY.name && !checkInData) {
                            checkInData = e;
                        } else if (e.accessType === ACCESS_TYPE_MATERIAL_MODEL.EXIT.name && !checkOutData) {
                            checkOutData = e;
                        }

                        if (checkInData && checkOutData) break;
                    }

                    setCheckInItem(CHECK_IN_MODEL.set(checkInData));
                    setCheckOutItem(CHECK_IN_MODEL.set(checkOutData));

                    if(checkInData?.equipmentList?.length > 0)
                        setEquipmentIn(equipmentListToLabel(checkInData?.equipmentList));

                    if(checkOutData?.equipmentList?.length > 0)
                        setEquipmentOut(equipmentListToLabel(checkOutData?.equipmentList));
                } else {
                    errorMsg(code);
                }
            });
    }

    return {
        t,
        checkInItem,
        checkOutItem,
        equipmentIn,
        equipmentOut
    };
};
